import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
    FiHome,
    FiPieChart,
    FiUser,
    FiBarChart2,
    FiUsers
} from 'react-icons/fi';

const BottomNavigation = ({ theme }) => {
    const location = useLocation();

    const navItems = [
        { id: 'home', icon: FiHome, label: 'Home', path: '/' },
        { id: 'team', icon: FiUsers, label: 'Team', path: '/team' },
        { id: 'trade', icon: FiBarChart2, label: 'Market', path: '/trade-list' },
        { id: 'staking', icon: FiPieChart, label: 'R-Trade', path: '/staking' },
        { id: 'profile', icon: FiUser, label: 'Profile', path: '/profile' },
    ];

    // Theme-based styles
    const navStyles = {
        light: {
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            borderClass: 'border-top border-light',
            activeColor: 'text-primary',
            inactiveColor: 'text-muted',
            iconColor: {
                active: '#007bff', // primary blue
                inactive: '#6c757d' // muted gray
            }
        },
        dark: {
            backgroundColor: 'rgba(0, 0, 0, 0.98)',
            borderClass: 'border-top border-secondary',
            activeColor: 'text-info',
            inactiveColor: 'text-light',
            iconColor: {
                active: '#17a2b8', // info teal
                inactive: '#f8f9fa' // light
            }
        }
    };

    const currentTheme = navStyles[theme];

    return (
        <motion.nav
            className={`position-fixed bottom-0 start-50 translate-middle-x z-3 ${currentTheme.borderClass}`}
            initial={{ y: 100 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            style={{
                width: '400px',
                maxWidth: '400px',
                height: '70px',
                backdropFilter: 'blur(10px)',
                backgroundColor: currentTheme.backgroundColor
            }}
        >
            <div className="row g-0 h-100">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = location.pathname === item.path;

                    return (
                        <div key={item.id} className="col h-100">
                            <Link
                                to={item.path}
                                className={`btn w-100 h-100 d-flex flex-column align-items-center justify-content-center p-2 border-0 text-decoration-none ${isActive ? currentTheme.activeColor : currentTheme.inactiveColor
                                    }`}
                            >
                                <motion.div
                                    animate={{
                                        scale: isActive ? 1.2 : 1,
                                    }}
                                    transition={{ duration: 0.2 }}
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.95 }}
                                >
                                    <Icon
                                        size={20}
                                        color={isActive ? currentTheme.iconColor.active : currentTheme.iconColor.inactive}
                                    />
                                </motion.div>
                                <motion.span
                                    className="small mt-1"
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{
                                        opacity: isActive ? 1 : 0.7,
                                        y: 0
                                    }}
                                >
                                    {item.label}
                                </motion.span>
                            </Link>
                        </div>
                    );
                })}
            </div>
        </motion.nav>
    );
};

export default BottomNavigation;